import {TranslateLoader} from "@ngx-translate/core";
import {catchError, forkJoin, map, Observable, of, filter, switchMap, take} from "rxjs";
import {HttpBackend, HttpClient} from "@angular/common/http";
import {merge} from "lodash";
import {Config, ConfigService} from "../../core/config";
import {environment} from "../../../environments/environment";

export interface TranslationResource {
  prefix: string;
  suffix?: string;
  optional?: boolean;
}

export class CustomTranslateHttpLoader implements TranslateLoader {

  constructor(
    private _handler: HttpBackend,
    private _config: ConfigService,
  ) {}

  private waitForConfigReady(): Observable<Config> {
    return this._config.configLoaded$.pipe(
      filter((cfg) => !!cfg),
      take(1)
    );
  }

  public getTranslation(lang: string): Observable<any> {
    return this.waitForConfigReady().pipe(
      switchMap((cfg) => {

        const resources: (string | TranslationResource)[] = [
          {
            prefix: `${environment.i18nPrefix}/assets/default/i18n/`,
            suffix: ".json"
          }
        ];

        if (cfg?.webapp?.languagesFiles?.length) {
          for (const file of cfg.webapp.languagesFiles) {
            if (file) {
              resources.push(file);
            }
          }
        }

        const requests: Observable<Object | {}>[] = resources.map((resource) => {
          let path: string;

          if (typeof resource === 'string') {
            if (resource.endsWith(`${lang}.json`)) {
              path = resource;
            } else {
              return of({});
            }
          } else {
            path = `${resource.prefix}${lang}${resource.suffix ?? '.json'}`;
          }

          return new HttpClient(this._handler).get(path).pipe(
            catchError((res) => {
              if (typeof resource !== 'string' && !resource.optional) {
                console.group();
                console.error('Something went wrong for the following translation file:', path);
                console.error(res);
                console.groupEnd();
              }
              return of({});
            }),
          );
        });

        return forkJoin(requests).pipe(
          map((response) => response.reduce((acc, curr) => merge(acc, curr), {})),
        );
      })
    );
  }
}
